import { IconAccess, IconAddon, IconAudit, IconFlag, IconOrgs, IconOverview } from '@shared/ui';

import type { ComponentType, SVGProps } from 'react';

export type NavItem = {
    label: string;
    href: string;
    icon: ComponentType<SVGProps<SVGSVGElement>>;
    count?: number;
    /** Rendered muted + non-navigable until the screen exists. */
    disabled?: boolean;
};

export type NavGroup = {
    label?: string;
    items: NavItem[];
};

/** Sidebar structure — matches the Backoffice mockup. */
export const NAV_GROUPS: NavGroup[] = [
    {
        items: [{ label: 'Overview', href: '/overview', icon: IconOverview }],
    },
    {
        label: 'Configuration',
        items: [
            // No static `count` anywhere: the flags badge is filled from the
            // live catalog by `Sidebar`, and the other screens get a badge when
            // they get an API to count from.
            { label: 'Feature Flags', href: '/flags', icon: IconFlag },
            { label: 'Add-ons', href: '/addons', icon: IconAddon },
        ],
    },
    {
        label: 'Tenants',
        items: [
            { label: 'Clients', href: '/clients', icon: IconOrgs },
            { label: 'Audit Log', href: '/audit', icon: IconAudit },
        ],
    },
    {
        label: 'System',
        items: [{ label: 'Access & Roles', href: '/access', icon: IconAccess, disabled: true }],
    },
];
